/*export const defaultVariabls = {
    url: "https://fifabestcoin.com/api",
    uploads: "https://fifabestcoin.com/uploads",
    React:"https://manage.fifabestcoin.com",
    website: "https://fifabestcoin.com",
    root: "fifabestcoin.com"
};*/
export const defaultVariabls = {
    url: "https://fifa.rnta.ir/api",
    uploads: "https://fifa.rnta.ir/uploads",
    React:"https://fipanel.rnta.ir",
    website: "https://fifa.rnta.ir",
    root: "fifa.rnta.ir"
};
/*export const defaultVariabls = {
    url: "http://localhost:8000/api",
    uploads: "http://localhost:8000/uploads",
    React:"http://localhost:3000",
    website: "http://127.0.0.1:8000",
    root: "localhost",
};*/


